angular.module('shared-components').component('gccsRateChangeInfo', {
  template: require('./template.pug'),
  controller: 'RateChangeInfoController',
  transclude: true,
  bindings: {
    rateChange: '<',
    onRemoveCb: '&'
  }
});
